import { render, staticRenderFns } from "./clickTxADQ.vue?vue&type=template&id=a5b70d70&scoped=true"
import script from "./clickTxADQ.vue?vue&type=script&lang=js"
export * from "./clickTxADQ.vue?vue&type=script&lang=js"
import style0 from "./clickTxADQ.vue?vue&type=style&index=0&id=a5b70d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b70d70",
  null
  
)

export default component.exports